<template>
    <div>
        <router-link :to="`/day-wallets/admin/pay-settlement/${row.id}`">
            <i class="fas fa-money-bill"></i>
        </router-link>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        props: {
            row: {
                required: true,
            },
            index: {
                required: true,
            },
            datatable: {
                required: true,
            },
        },
    })
</script>
